import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { HoldingTypeInfo } from '../../models/polymer/HoldingTypeInfo.model'
import { BASEURL_POLYMER, SUB_PATH_BASIC } from '../../utils/api'
interface QueryParams {
  hdb_ref: string
  uinfin: string
  singpass_token: string

}
export const holdingTypeApi = createApi({
  reducerPath: 'holdingTypeApi',
  baseQuery: fetchBaseQuery({ baseUrl: BASEURL_POLYMER,
  prepareHeaders:(headers,{getState})=>{
    headers.set("Access-Control-Request-Method", "POST");
    headers.set("X-Content-Type-Options", "nosniff");
  }}),
  endpoints: (builder) => ({
    getHoldingTypeApiByHdbRef: builder.query<HoldingTypeInfo, QueryParams>({
      query: (queryParams: QueryParams) => ({
        method: "POST",
        url:`${SUB_PATH_BASIC}/sharehldDetails`,
        body:{
          hdb_ref: queryParams.hdb_ref,
        },
        headers: {
          uinfin: queryParams.uinfin,
          Authorization: `Bearer ${queryParams.singpass_token}`
        },
      }),
      keepUnusedDataFor:1,
    }),
   
  }),
})

export const { useGetHoldingTypeApiByHdbRefQuery } = holdingTypeApi

